<template>
  <v-container
    ref="billing-content"
    fluid
  >
    <v-row>
      <v-col
        cols="12"
        class="px-0"
      >
        <div class="box">
          <div>
            <div class="d-flex justify-space-between">
              <div class="text-h3">
                Billing Details
              </div>
              <div>
                <span>Date:</span>
                <span class="ml-2">
                  {{ item.started_at | formatDate("DD-MM-YYYY") }}
                </span>
              </div>
            </div>
            <span> Cost breakdown for this charging session</span>
          </div>
          <div class="bill-info">
            <div>
              <span>Start Time:</span>
              <span class="ml-2">
                {{ item.started_at | formatTime }}
              </span>
            </div>
            <div>
              <span>End Time:</span>
              <span class="ml-2">
                {{ item.completed_at | formatTime }}
              </span>
            </div>
          </div>
          <!--  -->
          <div class="detail">
            <label for=""> Energy Consumption </label>
            <span>{{ item.energy_consumed }} kWh</span>
          </div>
          <v-divider />
          <div class="sub-total">
            <div>
              <label for=""> Energy Cost </label>
              <span>{{ item.energy_cost }} PKR</span>
            </div>
            <div>
              <label for=""> Service Fee </label>
              <span>-- </span>
            </div>
            <div>
              <label for=""> Tax </label>
              <span>{{ item.tax_cost }} PKR</span>
            </div>
          </div>
          <v-divider />
          <div class="total">
            <label for=""> Total </label>
            <span>PKR {{ item.total_cost }}</span>
          </div>

          <!--  -->

          <div class="payment-info">
            <label for="">Payment Information</label>
            <div class="info-section">
              <div>
                <label for=""> Payment Method </label>
                <span>Credit Card</span>
              </div>
              <div>
                <label for=""> Transaction ID</label>
                <span>TXN-488547</span>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
//
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
//
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pdfLogo: require("@/assets/brandLogo/pdfLogo.png"),
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
    }),
  },
  methods: {
    downloadFile(v) {
      const fileName = "Charging Session Detail - Billing";
      if (v === "pdf") {
        this.downloadPDF(fileName);
      } else if (v === "csv") {
        this.downloadCSV(fileName);
      } else if (v === "excel") {
        this.downloadExcel(fileName);
      }
    },
    async downloadPDF(fName = "Charging Session Detail - Billing") {
      const el = this.$refs["billing-content"];

      const canvas = await html2canvas(el, {
        scale: 2,
        useCORS: true,
        logging: false,
      });

      const imgData = canvas.toDataURL("image/png");

      const imgProps = {
        width: canvas.width,
        height: canvas.height,
      };

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const horizontalPadding = 10; // 10px padding left and right

      // Max allowed width for image considering padding
      const maxImgWidth = pageWidth - horizontalPadding * 2;
      const maxImgHeight = pageHeight - 80; // leave room for logo + title

      // Scale the image
      const ratio = Math.min(
        maxImgWidth / imgProps.width,
        maxImgHeight / imgProps.height
      );
      const imgWidth = imgProps.width * ratio;
      const imgHeight = imgProps.height * ratio;

      const x = horizontalPadding; // 10px from left
      const y = 100; // 60px from top to leave space for logo/title

      // Add logo and title
      if (this.authUser.isAdmin) {
        pdf.addImage(this.pdfLogo, "PNG", pageWidth - 60, 10, 50, 20); // 60 is width + margin
      } else {
        const bLogo = this.authUser?.business_logo;
        pdf.addImage(bLogo, "PNG", pageWidth - 60, 20, 50, 50);
      }

      pdf.setFontSize(20);
      pdf.text(`${fName}`, 14, 50);

      pdf.setFontSize(16);
      pdf.text(`Session #${this.item?.id}`, 15, 70);
      pdf.text(
        `${this.item?.charge_point_id} /${this.item?.connector_id}`,
        15,
        85
      );

      // Add image of the component
      pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);

      pdf.save(`${fName}.pdf`);
    },
    downloadCSV(fName = "Charging Session Detail - Billing") {
      const csvRows = [];

      // Header
      csvRows.push(["Billing Details"]);
      csvRows.push([
        "Date",
        this.$options.filters.formatDate(this.item.started_at, "DD-MM-YYYY"),
      ]);
      csvRows.push([]);

      // Session Info
      csvRows.push([
        "Start Time",
        this.$options.filters.formatTime(this.item.started_at),
      ]);
      csvRows.push([
        "End Time",
        this.$options.filters.formatTime(this.item.completed_at),
      ]);
      csvRows.push(["Energy Consumption", `${this.item.energy_consumed} kWh`]);
      csvRows.push([]);

      // Charges
      csvRows.push(["Energy Cost", `${this.item.energy_cost} PKR`]);
      csvRows.push(["Service Fee", `--`]);
      csvRows.push(["Tax", `${this.item.tax_cost} PKR`]);
      csvRows.push(["Total", `PKR ${this.item.total_cost}`]);
      csvRows.push([]);

      // Payment Info
      csvRows.push(["Payment Information"]);
      csvRows.push(["Payment Method", "Credit Card"]);
      csvRows.push(["Transaction ID", "TXN-488547"]);

      // Convert array to CSV string
      const csvContent = csvRows
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${fName}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadExcel(fName = "Charging Session Detail - Billing") {
      const item = this.item;

      const rows = [
        ["Billing Details", ""],
        [
          "Date",
          this.$options.filters.formatDate(item.started_at, "DD-MM-YYYY"),
        ],
        [],
        ["Start Time", this.$options.filters.formatTime(item.started_at)],
        ["End Time", this.$options.filters.formatTime(item.completed_at)],
        ["Energy Consumption", `${item.energy_consumed} kWh`],
        [],
        ["Energy Cost", `${item.energy_cost} PKR`],
        ["Service Fee", "--"],
        ["Tax", `${item.tax_cost} PKR`],
        ["Total", `PKR ${item.total_cost}`],
        [],
        ["Payment Method", "Credit Card"],
        ["Transaction ID", "TXN-488547"],
      ];

      // Convert array of arrays to worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(rows);

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Billing Details");

      // Export
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, `${fName}.xlsx`);
    },
  },
};
</script>
<style lang="sass" scoped>
.box
    border: 1px solid lightgray
    border-radius: 5px
    padding: 1rem
    .bill-info
      div
        display: flex
        justify-content: flex-end
    .detail
      font-size: 18px !important
      margin: 1rem 0
      display: flex
      justify-content: space-between
      span
        color: #000

    .sub-total
      margin: 1rem 0
      div
        display: flex
        justify-content: space-between
    .total
      color: #000
      margin: 1rem 0
      font-size: 18px
      font-weight: 600
      display: flex
      justify-content: space-between

    .payment-info
      >label
        font-weight: 600
        color: #000
      .info-section
        background: #eee
        padding: 2rem
        div
          display: flex
          justify-content: space-between
          span
            color: #000


.text-h3
  font-weight: 600
</style>
